import { path } from "ramda";
import {
  CHANGE_DECISION_DETAILS,
  MODAL_MQ_CHANGE_DECISION_OPEN,
} from "../types";

export const selectModalMQChangeDecisionOpen = path([
  "changeDecisionModalsReducer",
  MODAL_MQ_CHANGE_DECISION_OPEN,
]);

export const selectDetailsChangeDecision = path([
  "changeDecisionModalsReducer",
  CHANGE_DECISION_DETAILS,
]);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/selectors/changeDecisionModalsSelector.js